<template>
  <NfFormItem icon="location" :label="label" @click="handleClick">
    <div class="select-wrapper" slot="right">
      <span class="text" :class="labelValue === placeholder ? 'placeholder' : ''">{{ labelValue }}</span>
      <i class="icon icon-arrow-right"></i>
      <BottomPicker
        v-model="showSelLocation"
        @confirm="handleSel"
        :dataList="regionData"
        title="选择地区"
        @click.stop="() => false"
        :mountElClass="mountElClass"
      >
      </BottomPicker>
    </div>
  </NfFormItem>
</template>

<script>
import NfFormItem from "./NfFormItem"
import BottomPicker from "@/components/BottomPicker"
import { mapGetters, mapActions } from "vuex"

export default {
  name: "uiFormItemLocation",
  props: {
    value: {
      type: Object,
      default() {
        return {}
      }
    },
    placeholder: {
      type: String,
      default: "请选择"
    },
    mountElClass: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: "地区"
    }
  },
  data() {
    return {
      selValue: "",
      showSelLocation: false
    }
  },
  methods: {
    ...mapActions({
      getRegionData: "activityInfo/getRegionData"
    }),
    handleClick() {
      this.showSelLocation = true
    },
    handleClose() {
      this.showSelLocation = false
    },
    handleSel(selInfo) {
      const regionName = selInfo.selItem[2].keyword || selInfo.selItem[1].keyword || selInfo.selItem[0].keyword
      const areaInfo = {
        cityId: selInfo.selItem[1].id,
        districtId: selInfo.selItem[2].id,
        name: regionName,
        provinceId: selInfo.selItem[0].id
      }
      this.$emit("input", areaInfo)
    },
    handleGetRegion() {
      if (this.regionData.length < 1) {
        this.getRegionData()
      }
    },
    init() {
      this.handleGetRegion()
    }
  },
  components: {
    NfFormItem,
    BottomPicker
  },
  computed: {
    ...mapGetters({
      regionData: "activityInfo/regionData"
    }),
    labelValue: {
      get() {
        return this.value.name === "其他其他其他" ? "其他" : this.value.name || this.placeholder
      },
      set(value) {
        this.$emit("input", value)
      }
    }
  },
  created() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.select-wrapper {
  display: flex;
  align-items: center;
  overflow: hidden;
  .text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 0.2rem;
    &.placeholder {
      color: #999999;
    }
  }
  .icon-arrow-right {
    width: 0.3rem;
    height: 0.3rem;
    background: url("../../assets/images/icon_arrow.png") no-repeat center;
    background-size: 100%;
    flex: none;
  }
}
</style>
